<style lang="sass" scoped>

</style>

<template>
    <div>
        <div class="px-44 pt-32 row">

            <div class="col-12">

                <el-form @submit="submit">

                    <el-error class="mb-16" :error="server_error"></el-error>

                    <template slot="default">
                        <div class="row">
                            <div class="col-12 col-md-10 col-lg-8">
                                <div class="row form-content">
                                    <div class="col-12"></div>
                                    <el-input class="col-6" v-model="currentUser.first_name" name="first_name" :label="$t('form-elements.first_name')" :placeholder="$t('form-elements.first_name_placeholder')"></el-input>
                                    <el-input class="col-6" v-model="currentUser.last_name" name="last_name" :label="$t('form-elements.last_name')" :placeholder="$t('form-elements.last_name_placeholder')"></el-input>
                                    <el-input class="col-6" v-model="currentUser.email" :disabled="true" name="email" type="email" :label="$t('form-elements.email')" :placeholder="$t('form-elements.email_placeholder')"></el-input>
                                    <el-select class="col-6" v-model="lang" @input="currentUser.locale = lang.value" name="language" :options="languages" :label="$t('form-elements.language')" :placeholder="$t('form-elements.language_placeholder')"></el-select>

                                    <!--                                     
                                    <div class="col-12 mt-32">
                                        <p class="text-primary-dark fw-b mb-8">{{ $t('pages.profile.password_settings') }}</p>
                                        <p class="mb-16">{{ $t('pages.profile.password_new_password') }}</p>
                                    </div>
                                    <el-input class="col-6" v-model="password" type="password" :name="$t('form-elements.password')" :label="$t('form-elements.password')" :placeholder="$t('form-elements.password_placeholder')"> </el-input>
                                    <el-input class="col-6" v-model="repeat_password" type="password" :name="$t('form-elements.password_repeat')" :label="$t('form-elements.password_repeat')" :placeholder="$t('form-elements.password_repeat_placeholder')"> </el-input>
                                    -->

                                </div>
                            </div>
                        </div>
                    </template>

                    <template slot="footer">
                        <div class="form-footer position-fixed px-lg-60">
                            <button class="btn btn-primary btn-block btn-lg-inline d-block d-lg-flex" v-bind:class="{ disabled : loading }">
                                {{ $t('general.save') }}
                                <template v-if="loading">
                                    <i-loader class="ml-2 i-20 my-auto"></i-loader>
                                </template>
                                <template v-if="success">
                                    <i-check class="ml-2 i-20 my-auto"></i-check>
                                </template>
                            </button>
                        </div>
                    </template>

                </el-form>
            </div>

        </div>
    </div>
</template>

<script>
import { ElInput, ElSelect, ElForm, ElError } from '@/components/forms'

// Extends
import hasForm from '@/components/forms/has-form';
import hasLanguages from '@/components/forms/has-languages';


export default {
    name: 'Admins-profile',

    mixins: [hasForm, hasLanguages],

    components: { ElInput, ElSelect, ElForm, ElError },

    data: () => ({
        personal_info: {
            language: null
        },

        password: '',
        repeat_password: ''
    }),

    mounted() {
        this.setLanguage(this.currentUser.locale)
    },

    methods: {
        submit() {
            this.$validator.validateAll().then(res => {
                if (res) {
                    this.loading = true
                    let promises = []
                    let user_id = this.currentUser.user.id
                    promises.push(this.$store.dispatch(`user/update`, { user_id, data: { first_name: this.currentUser.first_name, last_name: this.currentUser.last_name, newsletter: 0, locale: this.currentUser.locale, phone: this.currentUser.phone } }))

                    Promise.all(promises).then(
                        () => this.handleSuccess('update_profile'),
                        (e) => this.handleError(e)
                    );
                }
            })
        }
    },

    computed: {
        currentUser() {
            return this.$store.getters['user/currentUser']
        }
    }

}
</script>
